import $api from '../http/index';
import { AxiosResponse } from "axios";
import { store } from "../index";
import $api2 from "../http/index2";

class NoteService {
    constructor(
        public id: number,
        public teacherId: string,
        public isDone: boolean,
        public nytitle: string,
        public categories: any,
    ) {
    }

    static createDrivingNote = async (newNote: any) => {
        console.log('NoteService.createDrivingNote called for:', newNote.nytitle, newNote.number); // Add this
        try {
            const response = await $api.post('/v1/drivingnotescreate', newNote);
            return response;
        } catch (error) {
            // console.error("Error in createDrivingNote:", error); // Already have throw
            throw error;
        }
    }

    static getAllDrivingNotes = async (): Promise<AxiosResponse<NoteService[]>> => {
        try {
            const studentId = store.user ? store.user.id : null;
            const response = await $api.get('/v1/drivingnotes', {
                headers: {
                    'studentid': studentId
                },
                withCredentials: true
            });
            return response;
        } catch (error) {
            throw '';
        }
    }

    static getDrivingNoteById = async (id: number): Promise<AxiosResponse<NoteService>> => {
        const response = await $api.get(`/v1/drivingnotes/${id}`);
        return response;
    }

    static updateDrivingNoteById = async (
        id: string,
        nytitle: string,
        statA: string,
        statB: string,
        statC: string,
        statD: string,
        statE: string,
        statF: string,
        statG: string,
        statH: string,
        statI: string,
        isDone: boolean
    ): Promise<AxiosResponse<NoteService>> => {
        const response = await $api.put(`/v1/drivingnotes/${id}`, {
            nytitle,
            statA,
            statB,
            statC,
            statD,
            statE,
            statF,
            statG,
            statH,
            statI,
            isDone
        });
        return response;
    }

    static deleteDrivingNoteById = async (groupId: any): Promise<AxiosResponse<void>> => {
        const response = await $api.delete(`/v1/drivingnotes/${groupId}`);
        return response;
    }

    static checkNameT = async (studentId: string): Promise<AxiosResponse<{ teacherName: string }>> => {
        const response = await $api.get(`/v1/checkNameT`, {params: {studentId}});
        return response;
    }

    static delHand = async (teacherId: any, studentId: any): Promise<AxiosResponse> => {
        const response = await $api.delete('/v1/delOneHand', {params: {teacherId, studentId}});
        return response;
    }



    // static getDescription = async (parameter: string, number: string, studentId: any) => {
    //     try {
    //         const studentId = store.user ? store.user.id : null;
    //         const suffix = store.user.autotransmission;
    //
    //         const response = await $api.post(`/v1/noteDescription`, { parameter, number, studentId, suffix });
    //
    //         return {
    //             text: response.data[parameter],
    //             images: response.data[`${parameter}img`] || [],
    //             videos: response.data[`${parameter}vid`] || [],
    //             audio: response.data[`${parameter}mp3`] || [],
    //         };
    //     } catch (error) {
    //         throw error;
    //     }
    // };


    static getDescription = async (parameter: string, number: string) => {
        try {
            const studentId = store.user?.id || null;
            const suffix = store.user?.autotransmission === true;
            console.log('client suf', suffix)
            const response = await $api.post(`/v1/noteDescription`, {
                parameter,
                number,
                studentId,
                suffix,
            });

            return {
                text: response.data[parameter],
                images: response.data[`${parameter}img`] || [],
                videos: response.data[`${parameter}vid`] || [],
                audio: response.data[`${parameter}mp3`] || [],
            };
        } catch (error) {
            throw error;
        }
    };




    static getDescription2 = async (parameter: string, number: string, studentId: string) => {
        try {
            const response = await $api2.post(`/v1/noteDescriptionT`, {
                parameter,
                number: Number(number),
                studentId
            });

            return {
                text: response.data[parameter],
                images: response.data[`${parameter}img`] || [],
                videos: response.data[`${parameter}vid`] || [],
                audio: response.data[`${parameter}mp3`] || [],
            };
        } catch (error) {
            throw error;
        }
    };



    static async getTranscribe(formData: FormData): Promise<AxiosResponse> {
        try {
            const response = await $api.post("/v1/transcribe", formData, {
                headers: {"Content-Type": "multipart/form-data"},
            });
            return response;
        } catch (error) {
            throw new Error("Failed to transcribe audio");
        }
    }

}

export default NoteService;